import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, CheckCircleIcon, AwardIcon, HeartIcon, RefreshCwIcon, UsersIcon } from 'lucide-react';
export const About: React.FC = () => {
  return <div className="min-h-screen bg-white dark:bg-gray-900 w-full" data-id="element-289">
      {/* Hero Section */}
      <section className="relative bg-gray-100 dark:bg-gray-800 py-16 md:py-24" data-id="element-290">
        <div className="container mx-auto px-4" data-id="element-291">
          <div className="max-w-3xl mx-auto text-center" data-id="element-292">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900 dark:text-white" data-id="element-293">
              <span className="text-gray-900 dark:text-white" data-id="element-294">Meist </span>
              <span className="text-gray-900 dark:text-white" data-id="element-295">Annelinna</span>
              <span className="text-yellow-500" data-id="element-296">Pandimaja</span>
            </h1>
            <p className="text-lg text-gray-700 dark:text-gray-300" data-id="element-297">
              Teie usaldusväärne allikas kvaliteetse kasutatud elektroonika ja
              väärismetallide jaoks.
            </p>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white dark:from-gray-900 to-transparent" data-id="element-298"></div>
      </section>
      {/* Our Story */}
      <section className="py-12 md:py-16" data-id="element-299">
        <div className="container mx-auto px-4" data-id="element-300">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-301">
            <div className="md:w-1/2" data-id="element-302">
              <h2 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white" data-id="element-303">
                Meie Lugu
              </h2>
              <p className="text-gray-700 dark:text-gray-300 mb-6" data-id="element-304">
                Asutatud 2020. aastal, Annelinna Pandimaja alustas lihtsa
                missiooniga: pakkuda kvaliteetseid kasutatud
                elektroonikaseadmeid ja väärismetalle, edendades samas
                jätkusuutlikkust ja eetilist hankimist.
              </p>
              <div className="flex items-center gap-4 mb-6" data-id="element-305">
                <div className="h-0.5 w-12 bg-yellow-500" data-id="element-306"></div>
                <span className="text-yellow-500 font-medium" data-id="element-307">Alates 2020</span>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-308">
                <div className="flex items-start" data-id="element-309">
                  <div className="mr-4 p-2 bg-yellow-100 dark:bg-yellow-900/30 rounded-full" data-id="element-310">
                    <RefreshCwIcon size={20} className="text-yellow-500" data-id="element-311" />
                  </div>
                  <div data-id="element-312">
                    <h3 className="font-semibold text-gray-900 dark:text-white mb-2" data-id="element-313">
                      Jätkusuutlikkus
                    </h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-314">
                      Edendame ringmajandust läbi taaskasutuse ja ringlussevõtu.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-315">
                  <div className="mr-4 p-2 bg-yellow-100 dark:bg-yellow-900/30 rounded-full" data-id="element-316">
                    <AwardIcon size={20} className="text-yellow-500" data-id="element-317" />
                  </div>
                  <div data-id="element-318">
                    <h3 className="font-semibold text-gray-900 dark:text-white mb-2" data-id="element-319">
                      Kvaliteet
                    </h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-320">
                      Ranged testimis- ja autentimisprotsessid.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="md:w-1/2" data-id="element-321">
              <div className="relative" data-id="element-322">
                <img src="https://images.unsplash.com/photo-1573164574572-cb89e39749b4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Annelinna Pandimaja kontor" className="rounded-lg shadow-lg w-full h-auto object-cover" data-id="element-323" />
                <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-yellow-500 rounded-full opacity-20" data-id="element-324"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Our Vision */}
      <section className="py-12 md:py-16 bg-gray-50 dark:bg-gray-800" data-id="element-325">
        <div className="container mx-auto px-4" data-id="element-326">
          <div className="max-w-3xl mx-auto text-center" data-id="element-327">
            <h2 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white" data-id="element-328">
              Meie Visioon
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-8" data-id="element-329">
              Annelinna Pandimajas näeme maailma, kus tehnoloogiale ja
              luksuskaupadele antakse teine elu, vähendades jäätmeid ja muutes
              kvaliteetsed tooted kättesaadavaks rohkematele inimestele. Usume
              ringmajandusse ja püüame hoida väärtuslikke ressursse kasutuses
              nii kaua kui võimalik.
            </p>
            <div className="flex justify-center" data-id="element-330">
              <Link to="/category/electronics" className="bg-yellow-500 hover:bg-yellow-600 text-white px-6 py-3 rounded-md font-medium transition-colors mr-4" data-id="element-331">
                Osta Elektroonikat
              </Link>
              <Link to="/category/gold" className="bg-transparent border border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-white px-6 py-3 rounded-md font-medium transition-colors" data-id="element-332">
                Sirvi Metalle
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Quality & Ethics */}
      <section className="py-12 md:py-16" data-id="element-333">
        <div className="container mx-auto px-4" data-id="element-334">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-335">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-8" data-id="element-336">
              <div className="flex items-center mb-6" data-id="element-337">
                <CheckCircleIcon size={24} className="text-yellow-500 mr-3" data-id="element-338" />
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-339">
                  Kvaliteedigarantii
                </h2>
              </div>
              <p className="text-gray-700 dark:text-gray-300 mb-6" data-id="element-340">
                Iga toode, mis läbib meie uksed, läbib põhjaliku testimise ja
                autentimise. Elektroonika puhul tähendab see põhjalikku
                diagnostilist testimist ja taastamist sertifitseeritud tehnikute
                poolt. Väärismetallide puhul kasutame tööstuse standardseid
                testimismeetodeid ja gemmoloogide ning metallurgide kinnitust.
              </p>
              <ul className="space-y-2" data-id="element-341">
                {['Põhjalik testimine', 'Sertifitseeritud tehnikud', 'Tööstuse standardmeetodid', 'Ekspertide kinnitus'].map((item, index) => <li key={index} className="flex items-center text-gray-700 dark:text-gray-300" data-id="element-342">
                    <span className="mr-2 text-yellow-500" data-id="element-343">✓</span> {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-8" data-id="element-344">
              <div className="flex items-center mb-6" data-id="element-345">
                <HeartIcon size={24} className="text-yellow-500 mr-3" data-id="element-346" />
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-347">
                  Eetiline Hankimine
                </h2>
              </div>
              <p className="text-gray-700 dark:text-gray-300 mb-6" data-id="element-348">
                Oleme pühendunud eetiliste hankimistavade järgimisele. Valime
                hoolikalt oma tarnijaid ja partnereid, tagades, et nad järgivad
                õiglase töö tavasid ja keskkonnastandardeid. Meie
                väärismetallide puhul eelistame ringlussevõetud allikaid ja
                konfliktivabaid materjale.
              </p>
              <ul className="space-y-2" data-id="element-349">
                {['Õiglase töö tavad', 'Keskkonnastandardid', 'Ringlussevõetud allikad', 'Konfliktivabad materjalid'].map((item, index) => <li key={index} className="flex items-center text-gray-700 dark:text-gray-300" data-id="element-350">
                    <span className="mr-2 text-yellow-500" data-id="element-351">✓</span> {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Community Impact */}
      <section className="py-12 md:py-16 bg-gray-50 dark:bg-gray-800" data-id="element-352">
        <div className="container mx-auto px-4" data-id="element-353">
          <div className="max-w-3xl mx-auto" data-id="element-354">
            <div className="flex items-center mb-8" data-id="element-355">
              <UsersIcon size={24} className="text-yellow-500 mr-3" data-id="element-356" />
              <h2 className="text-3xl font-bold text-gray-900 dark:text-white" data-id="element-357">
                Kogukonna Mõju
              </h2>
            </div>
            <p className="text-gray-700 dark:text-gray-300 mb-8" data-id="element-358">
              Annelinna Pandimaja on rohkem kui lihtsalt äri—oleme kogukond.
              Korraldame regulaarselt hariduslikke töötubasid jätkusuutliku
              tehnoloogia ja väärismetallidesse investeerimise teemal. Osa meie
              kasumist läheb keskkonnakaitse pingutustele ja digitaalse
              kirjaoskuse programmidele alaesindatud kogukondades.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6" data-id="element-359">
              <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-sm" data-id="element-360">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-2" data-id="element-361">
                  Hariduslikud Töötoad
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-362">
                  Regulaarsed sessioonid jätkusuutliku tehnoloogia ja
                  väärismetallide investeerimise teemal.
                </p>
              </div>
              <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-sm" data-id="element-363">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-2" data-id="element-364">
                  Keskkonnakaitse
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-365">
                  Toetame algatusi meie planeedi loodusvarade kaitsmiseks.
                </p>
              </div>
              <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-sm" data-id="element-366">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-2" data-id="element-367">
                  Digitaalne Kirjaoskus
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-368">
                  Programmid tehnoloogiliste oskuste edendamiseks alaesindatud
                  kogukondades.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Thank You & Contact */}
      <section className="py-12 md:py-16" data-id="element-369">
        <div className="container mx-auto px-4" data-id="element-370">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-371">
            <h2 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white" data-id="element-372">
              Täname Teid
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-8" data-id="element-373">
              Täname, et valisite Annelinna Pandimaja. Iga teie ost toetab meie
              missiooni jätkusuutlikkuse, kvaliteedi ja eetiliste äritavade
              osas.
            </p>
            <div className="h-0.5 w-24 bg-yellow-500 mx-auto" data-id="element-374"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-375">
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm" data-id="element-376">
              <h3 className="font-semibold text-gray-900 dark:text-white mb-4" data-id="element-377">
                Kiirlingid
              </h3>
              <ul className="space-y-2" data-id="element-378">
                <li data-id="element-379">
                  <Link to="/about" className="text-yellow-500 hover:text-yellow-600 dark:hover:text-yellow-400" data-id="element-380">
                    Meist
                  </Link>
                </li>
                <li data-id="element-381">
                  <Link to="/shipping" className="text-yellow-500 hover:text-yellow-600 dark:hover:text-yellow-400" data-id="element-382">
                    Tarneinfo
                  </Link>
                </li>
                <li data-id="element-383">
                  <Link to="/returns" className="text-yellow-500 hover:text-yellow-600 dark:hover:text-yellow-400" data-id="element-384">
                    Tagastused
                  </Link>
                </li>
              </ul>
            </div>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm" data-id="element-385">
              <h3 className="font-semibold text-gray-900 dark:text-white mb-4" data-id="element-386">
                Kategooriad
              </h3>
              <ul className="space-y-2" data-id="element-387">
                <li data-id="element-388">
                  <Link to="/category/electronics" className="text-yellow-500 hover:text-yellow-600 dark:hover:text-yellow-400" data-id="element-389">
                    Elektroonika
                  </Link>
                </li>
                <li data-id="element-390">
                  <Link to="/category/gold" className="text-yellow-500 hover:text-yellow-600 dark:hover:text-yellow-400" data-id="element-391">
                    Väärismetallid
                  </Link>
                </li>
              </ul>
            </div>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm" data-id="element-392">
              <h3 className="font-semibold text-gray-900 dark:text-white mb-4" data-id="element-393">
                Kontakt
              </h3>
              <ul className="space-y-3" data-id="element-394">
                <li className="flex items-center text-gray-700 dark:text-gray-300" data-id="element-395">
                  <Mail size={16} className="mr-2 text-yellow-500" data-id="element-396" />
                  <a href="mailto:info@annelinnapandimaja.com" className="hover:text-yellow-500" data-id="element-397">
                    info@annelinnapandimaja.com
                  </a>
                </li>
                <li className="flex items-center text-gray-700 dark:text-gray-300" data-id="element-398">
                  <Phone size={16} className="mr-2 text-yellow-500" data-id="element-399" />
                  <a href="tel:+37251234567" className="hover:text-yellow-500" data-id="element-400">
                    +372 5123 4567
                  </a>
                </li>
                <li className="flex items-center text-gray-700 dark:text-gray-300" data-id="element-401">
                  <MapPin size={16} className="mr-2 text-yellow-500" data-id="element-402" />
                  <span data-id="element-403">Annelinn, Tartu, Eesti</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>;
};